import { common } from '../common'

export const isZendeskAppVisible = () => {
  return common.isModuleActive('zendeskFederatedSearch') || common.isModuleActive('zendeskTicketEscalation') || common.isModuleActive('analyticsV2SelfService')
}

export const isZapierAppVisible = () => {
  return common.isModuleActive('zapier')
}

export const isGainsightAppVisible = () => {
  return common.isModuleActive('gainsight')
}

export const isSalesforceAppVisible = () => {
  return (common.isModuleActive('salesforceCrm') || common.isModuleActive('salesforceFederatedSearch') || common.isModuleActive('salesforceCaseEscalation') || common.isModuleActive('salesforceSyncAccountData'))
}
